<template>
  <div class="row categories">
    <div class="col-lg-9 col-md-10 col-sm-12 ">
      
      <div class="card">
        <div :class="(loading ? 'show-loader' : 'hide-loader')">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg><!---->
          </div>
        </div>
        <div class="card-header">
        </div>
        <div class="card-content row">
          <div class="col-sm-12">
            <div class="pull-right" style="position:relative;z-index:2">
              <router-link class="btn btn-info" title="" :to="{ path: 'categories/add'}"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogCateg.single')}}</router-link>
            </div>
            <!-- <div class="pull-left">
              <el-input v-model="filters[0].value" placeholder="Search" class="icon-search"></el-input>
            </div> -->
          </div>
          <table class="table " ref="sortableTable">
            <thead>
              <tr>
                <th></th>
                <th>{{$t('catalogCateg.image')}}</th>
                <th>{{$t('catalogCateg.name')}}</th>
                <th width="30px"></th>
              </tr>
            </thead>
            <draggable v-model="tableData" :element="'tbody'" @end="adjustSort">
              <template v-for="(item, index) in tableData">
                <tr class="sortableRow" :key="item.id" @click="goToRecord(item,[],[], $event)">
                  <td >
                    <!-- <button style="cursor: move" class="btn"><v-icon>drag_handle</v-icon></v-btn> -->
                      <i style="cursor: move" class="fa fa-arrows sortHandle"></i>
                  </td>
                  <td ><div class="cell"><img v-bind:src="(item.image)?item.image : ''" /></div></td>
                  <td>{{ item.name }}</td>
                  <td><i class="fa fa-pencil"></i></td>
                </tr>
              </template>
            </draggable>
          </table>

           
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Col, Input, Table, TableColumn, Row, Select, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Col)
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Row)
  Vue.use(Select)
  Vue.use(Option)
  Vue.use(DataTables)
  export default{
    components: {
      PPagination,
      PSwitch,
      draggable
    },
    computed: {
    },
    data () {
      return {
        loading: true,
        paginationDef: {
          pageSize: 10,
          currentPage: 1,
          pageSizes: [10, 25, 50],
          show: true
        },
        searchDef: {
          colProps: {
            span: 14
          }
        },
        searchQuery: '',
        propsToSearch: ['name'],
        tableColumns: [
        ],
        tableData: [],
        filters: [
          {
            value: '',
            prop: ['name', 'parent_category']
          }
        ]
      }
    },
    created: function () {
      this.$nextTick(function () {
        this.loading = true
      })
      var self = this
      console.warn(this.$store.getters.loggedInUser)
      var data = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany'),
        use_sort_order: 'asc'
      }
      this.apiRequest('/category', 'GET', data, function (response) {
        if (response.status === true) {
          self.tableData = response.data
        }
        self.$nextTick(function () { self.loading = false })
      })
    },
    methods: {
      formatCategName (row) {
        if (row['parent_id']) {
          return row['parent_category']['name'] //  + ' > ' + row['name']
        } else {
          return '' // row['name']
        }
      },
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/categories/edit/')
      },
      adjustSort (evt) {
        if (this.tableData.length > 1) {
          var idx = evt.newIndex
          var after, before, sortOrder

          if (idx === 0) {
            console.warn('first')
            before = 0
            after = this.tableData[idx + 1].sort_order
          } else if ((idx + 1) === this.tableData.length) {
            console.warn('last')
            before = this.tableData[idx - 1].sort_order
            after = parseFloat(before) + 1
          } else {
            console.warn('middle')
            before = this.tableData[idx - 1].sort_order
            after = this.tableData[idx + 1].sort_order
          }

          sortOrder = (parseFloat(before) + parseFloat(after)) / 2
          var id = this.tableData[idx].id

          var data = {
            id: id,
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany'),
            sort_order: sortOrder
          }

          var self = this
          this.apiRequest('/category/' + id, 'PUT', data, function (response) {
            if (response.status !== true) {
              swal(
                {
                  title: '',
                  text: self.$t('validations.dataCouldNotBeSaved'),
                  type: 'danger',
                  showConfirmButton: false,
                  timer: 1500
                }
              ).catch(() => {}) // end swal
            }
          })
        }
      }
    }
  }
</script>
<style>
 
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Categories/Categories.vue